module.exports = __webpack_public_path__ + "static/employer-loan-72a1a06041036a187d812a696ff5b718.png";